import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { catchError, Observable, of } from 'rxjs';
import { OrgaoService } from 'src/app/shared/services/orgao.service';

@Injectable({
  providedIn: 'root'
})
export class ListOrgaoResolver implements Resolve<boolean> {

  constructor(private service: OrgaoService) { }

  resolve(): Observable<any> {
    return this.service.findAll();
  }
}
@Injectable({
  providedIn: 'root'
})
export class ListOrgaoAllResolver implements Resolve<boolean> {

  constructor(private service: OrgaoService) { }

  resolve(): Observable<any> {
    return this.service.getOrgaosAll().pipe(
      catchError(error => {
        return of({ error: true, message: error.message });
      })
    );
  }
}

@Injectable({
  providedIn: 'root'
})
export class ListOrgaoProgramaResolver implements Resolve<boolean> {

  constructor(private service: OrgaoService) { }

  resolve(): Observable<any> {
    return this.service.getOrgaosPrograma();
  }
}

@Injectable({
  providedIn: 'root'
})
export class ListOrgaoAgregadorResolver implements Resolve<boolean> {

  constructor(private service: OrgaoService) { }

  resolve(): Observable<any> {
    return this.service.getOrgaosAgregador();
  }
}